var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgMessage(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16ZM32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM8 11.5C8 10.6875 8.65625 10 9.5 10H22.5C23.3125 10 24 10.6875 24 11.5V20.5C24 21.3438 23.3125 22 22.5 22H9.5C8.65625 22 8 21.3438 8 20.5V11.5ZM22.5 12.7812V11.5H9.5V12.7812C10.0593 13.2643 10.9081 13.9334 12.4839 15.1757C12.8451 15.4604 13.2446 15.7753 13.6875 16.125C13.7853 16.1998 13.9 16.2947 14.0268 16.3996C14.5889 16.8645 15.3881 17.5255 16 17.5C16.5832 17.5254 17.3721 16.8718 17.9328 16.4073C18.0631 16.2994 18.1811 16.2016 18.2812 16.125C18.9598 15.5893 19.5364 15.1352 20.0305 14.746C21.2659 13.773 21.9866 13.2054 22.5 12.7812ZM9.5 14.7188V20.5H22.5V14.7188C21.7812 15.2812 20.75 16.0938 19.2188 17.3125C19.0936 17.405 18.9543 17.5174 18.8025 17.6398C18.0827 18.2203 17.084 19.0258 16 19C14.849 19.0268 13.7897 18.1593 13.0774 17.5761C12.9581 17.4784 12.8486 17.3887 12.75 17.3125C12.3148 16.9661 11.9199 16.6525 11.5619 16.3681C10.6603 15.6521 9.99209 15.1214 9.5 14.7188Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgMessage);
export default __webpack_public_path__ + "static/media/img_message.ef31f9acc0c3e420abe6f493e710b00b.svg";
export { ForwardRef as ReactComponent };